module.exports = __webpack_public_path__ + "img/login_logo.4e3cc56a.png";